import { ComponentButton } from './ComponentButton';
import { ReloadButton as ReloadButtonType } from '@/schemas/sceneDataSchema';

export const ReloadButton = ({ component }: { component: ReloadButtonType }) => {
  const onClick = () => {
    location.replace(location.origin);
  };

  return (
    <ComponentButton
      onClick={onClick}
      component={component}
      type='button'
    />
  );
};
